import { render, staticRenderFns } from "./StrategyCategoryPanel.vue?vue&type=template&id=63e67ab4&scoped=true&"
import script from "./StrategyCategoryPanel.vue?vue&type=script&lang=js&"
export * from "./StrategyCategoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./StrategyCategoryPanel.vue?vue&type=style&index=0&id=63e67ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e67ab4",
  null
  
)

export default component.exports